/**
 * Modern Loading Throbber Component for TECDocChart
 * 
 * Replaces the old ajax-loader.gif with a modern CSS-based spinner
 * that matches the TECDoc design system and provides better performance.
 */

import React from 'react';
import './LoadingThrobber.css';

export interface LoadingThrobberProps {
  /** Size variant of the throbber */
  size?: 'sm' | 'md' | 'lg';
  /** Color variant */
  color?: 'primary' | 'white' | 'red';
  /** Whether to show the throbber */
  visible?: boolean;
  /** Custom className */
  className?: string;
  /** Optional text to show below spinner */
  text?: string;
}

/**
 * Modern CSS-based loading throbber component
 */
export const LoadingThrobber: React.FC<LoadingThrobberProps> = ({
  size = 'md',
  color = 'primary',
  visible = true,
  className = '',
  text
}) => {
  if (!visible) return null;

  const throbberClasses = [
    'tec-loading-throbber',
    `tec-loading-throbber--${size}`,
    `tec-loading-throbber--${color}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={throbberClasses}>
      <div className="tec-loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {text && <span className="tec-loading-text">{text}</span>}
    </div>
  );
};

/**
 * Global loading throbber for the top bar
 * Positioned absolutely to match original master.html placement
 */
export const TopBarThrobber: React.FC<{ visible: boolean }> = ({ visible }) => (
  <div className={`tec-top-bar-throbber ${visible ? 'visible' : 'hidden'}`}>
    <LoadingThrobber size="sm" color="primary" visible={visible} />
  </div>
);

export default LoadingThrobber;